const wallMixedCarousel = {
    WallMixedCarousel: {
        baseStyle: () => ({
            wrapper: {
                w: '100%',
                position: 'relative',
                overflow: 'hidden',
            },
        }),
    },
}

export default wallMixedCarousel
